import React from 'react';
import {CreateDeliveryForm} from '../models/distribution.model';
import Button from '../../../Presentation/components/ui/Button';
import {Plus} from 'lucide-react';

interface DeliveryFormActionsProps {
  formData: CreateDeliveryForm;
  submitting: boolean;
  isLoading: boolean;
  onReset: () => void;
}

const DeliveryFormActions: React.FC<DeliveryFormActionsProps> = ({
  formData,
  submitting,
  isLoading,
  onReset
}) => {
  const isDisabled = submitting || isLoading || !formData.marketerId || !formData.productId;

  return (
    <div className="flex gap-4">
      <Button
        type="submit"
        disabled={isDisabled}
        isLoading={submitting}
        className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3"
      >
        <Plus className="h-4 w-4" />
        {submitting ? 'جاري التسليم...' : 'تسليم المنتج'}
      </Button>

      <Button
        type="button"
        variant="ghost"
        onClick={onReset}
        className="px-6 py-3"
      >
        إعادة تعيين
      </Button>
    </div>
  );
};

export default DeliveryFormActions;
